<script lang="ts">
  import { MetafyPartnerEnum } from '$lib/types/api/graphql';
  import { BadgeSizeClasses, type BadgeSize } from '.';

  import { tooltip as tooltipDirective } from '$lib/directives/tooltip';

  import BadgeCore from '$assets/svgs/badges/core.svg?component';
  import BadgePro from '$assets/svgs/badges/pro.svg?component';
  //import BadgeUltra from '$assets/svgs/badges/ultra.svg?component';
  import { capitalize } from '$lib/utils';

  export let size: BadgeSize = 'lg';
  export let variant: MetafyPartnerEnum | null = MetafyPartnerEnum.Pro;
  export let tooltip = `Metafy ${capitalize(variant ?? 'Partner')}`;

  let className = '';
  export { className as class };
</script>

<span
  class="relative inline-flex aspect-square {BadgeSizeClasses[
    size
  ]} {className} before:absolute before:-inset-3 before:rounded-full"
  use:tooltipDirective={{
    content: tooltip,
    placement: 'top',
    disableMobile: true,
    enabled: !!tooltip
  }}
>
  <svelte:component this={variant === MetafyPartnerEnum.Core ? BadgeCore : BadgePro} class="size-full" />
</span>
